export default __webpack_public_path__ + "static/media/qldsTheme.9859546e.png";